export const factoryConstants = {
    LIST_SUCCESS: 'FACTORY_LIST_SUCCESS',
    LIST_FAILURE: 'FACTORY_LIST_FAILURE',

    BULK_UPDATE_SUCCESS: 'FACTORY_BULK_UPDATE_SUCCESS',
    BULK_UPDATE_FAILURE: 'FACTORY_BULK_UPDATE_FAILURE',

    CLEAR_FACTORY_CHANGE_ERROR: 'CLEAR_FACTORY_CHANGE_ERROR',
};
